import gql from 'graphql-tag';
import {
  AddressComponentDataChange,
  AuditCheckboxComponentDataChange,
  AuditTagComponentDataChange,
  AuditTextComponentDataChange,
  DateComponentDataChange,
  EmailComponentDataChange,
  FileComponentDataChange,
  GeolocationComponentDataChange,
  NumberComponentDataChange,
  PersonComponentDataChange,
  RelatedCardComponentDataChange,
  ScheduledAutomationComponentDataChange,
  SignatureComponentDataChange,
  SubformComponentDataChange,
  TagComponentDataChange,
  TextComponentDataChange,
  TimeTrackerComponentDataChange,
  TodoComponentDataChange,
  UrlComponentDataChange,
} from './component';
import * as user from './user';

const reminder = gql`
  fragment CardReminder on CardReminder {
    duration
    relativeTo
    recipientFieldName
    conditionalSelector
  }
`;

const recurrence = gql`
  fragment CardRecurrence on EntityRecurrence {
    id
    rule
  }
`;

export const card = gql`
  fragment Card on Card {
    id
    userId
    channelId
    cardDefinitionId
    workflowTemplateId
    createdAt
    updatedAt
    urgent
    timezone
    fields
    startDate
    endDate
    recurrenceDate
    kanbanSortKey
    sequenceNumber
    status
    planLimitImposed
    threadId
    assignees {
      ...ShortUser
    }
    recurrence: entityRecurrence {
      ...CardRecurrence
    }
    reminders: cardReminders {
      ...CardReminder
    }
    relatedCards {
      id
      name
    }
  }

  ${recurrence}
  ${reminder}
  ${user.short}
`;

export const uiTemplate = gql`
  fragment CardUITemplate on CardUITemplate {
    id
    type
    template
  }
`;

export const definition = gql`
  fragment CardDefinition on CardDefinition {
    id
    name
    appId
    definition
    imageUrl
    workspaceFocus
    workspacePurpose
    templates: cardUITemplates {
      ...CardUITemplate
    }
    root
  }

  ${uiTemplate}
`;

export const tag = gql`
  fragment TagOption on CardFieldStringTag {
    id
    channelId
    colorName
    label
    sortKey
    slug
    fieldName
    archivedAt
  }
`;

export const workflowListItem = gql`
  fragment WorkflowListItem on WorkflowListItem {
    id
    name
    description
    workflowListItemAssociations {
      cardDefinition {
        id
        name
        iconName
        imageUrl
        definition
        workspacePurpose
      }
      workflowTemplate {
        id
        name
        cardDefinition {
          name
          iconName
          imageUrl
          definition
          workspacePurpose
        }
        channelDefaultConfiguration {
          id
          imageUrl
        }
      }
    }
  }
`;

export const fragmentTemplate = gql`
  fragment FragmentTemplate on CardFragmentTemplate {
    id
    channelId
    name
    template
    createdAt
  }
`;

export const cardExport = gql`
  fragment Export on Export {
    url
  }
`;

export const change = gql`
  fragment AnyComponentDataChange on AnyComponentDataChange {
    ...AddressComponentDataChange
    ...AuditCheckboxComponentDataChange
    ...AuditTagComponentDataChange
    ...AuditTextComponentDataChange
    ...DateComponentDataChange
    ...EmailComponentDataChange
    ...FileComponentDataChange
    ...GeolocationComponentDataChange
    ...NumberComponentDataChange
    ...PersonComponentDataChange
    ...RelatedCardComponentDataChange
    ...ScheduledAutomationComponentDataChange
    ...SignatureComponentDataChange
    ...SubformComponentDataChange
    ...TagComponentDataChange
    ...TextComponentDataChange
    ...TimeTrackerComponentDataChange
    ...TodoComponentDataChange
    ...UrlComponentDataChange
  }

  ${AddressComponentDataChange}
  ${AuditCheckboxComponentDataChange}
  ${AuditTagComponentDataChange}
  ${AuditTextComponentDataChange}
  ${DateComponentDataChange}
  ${EmailComponentDataChange}
  ${FileComponentDataChange}
  ${GeolocationComponentDataChange}
  ${NumberComponentDataChange}
  ${PersonComponentDataChange}
  ${RelatedCardComponentDataChange}
  ${ScheduledAutomationComponentDataChange}
  ${SignatureComponentDataChange}
  ${SubformComponentDataChange}
  ${TagComponentDataChange}
  ${TextComponentDataChange}
  ${TimeTrackerComponentDataChange}
  ${TodoComponentDataChange}
  ${UrlComponentDataChange}
`;
